/**
 * The built-in demo dataset: the trial mode's end-to-end run with no
 * upload (DESIGN_RECORD item 5; brief trial policy S3). The demo is
 * the Maine county poverty sample itself — the same file the panel
 * offers as a download — parsed through the real CSV reader and
 * converted through the real area-level mapping, so the trial
 * exercises exactly the code a paying user's file exercises.
 */
import { tableToAreaLevelCell } from './area-level.js';
import { AREA_LEVEL_TEMPLATE_CSV, MAINE_COUNTY_POVERTY_SAMPLE_CSV, } from './demo-data.js';
import { parseDelimitedText } from './delimited.js';
export const DEMO_SAMPLE_FILENAME = 'maine_county_poverty_sample.csv';
export const DEMO_TEMPLATE_FILENAME = 'sae_area_level_template.csv';
/** The sample file's contents, for the panel's sample download. */
export function sampleCsvText() {
    return MAINE_COUNTY_POVERTY_SAMPLE_CSV;
}
/** The blank template's contents, for the panel's template download. */
export function templateCsvText() {
    return AREA_LEVEL_TEMPLATE_CSV;
}
/** Parse the demo dataset into a table (percent scale, as stored). */
export function demoTable() {
    return parseDelimitedText(MAINE_COUNTY_POVERTY_SAMPLE_CSV, {
        format: 'csv',
    });
}
/**
 * The demo as an engine-ready area-level input: sixteen counties,
 * percent scale declared explicitly, covariates snap_rate,
 * unemployment_rate, and median_household_income. The sample file's
 * population column is mapped as the population-count role, so the
 * demo run benchmarks like any complete user run (re-review RB-4,
 * fix 4; the counts' source is recorded in demo-data.ts).
 */
export function demoAreaLevelInput() {
    const { table } = demoTable();
    return tableToAreaLevelCell(table, {
        area: 'county',
        estimate: 'direct_pct',
        variance: 'sampling_variance',
        sampleSize: 'n',
        populationCount: 'population',
        covariates: ['snap_rate', 'unemployment_rate', 'median_household_income'],
        indicatorId: 'poverty_rate',
    }, { estimateScale: 'percent' });
}
//# sourceMappingURL=demo.js.map